interface ToggleButtonProps {
    isOn: boolean;
    onToggle: () => void;
    disabled?: boolean;
} 

const ToggleButton: React.FC<ToggleButtonProps> = ({
    isOn,
    onToggle,
    disabled = false,
}) => {

    const handleClick = () => {
       if (!disabled) {
         onToggle();
       }
    };

    return (
        <>
            {isOn?
                <div className={`w-10 h-5 rounded-full bg-blue-600 ${disabled ? "cursor-not-allowed" : "cursor-pointer"}`} onClick={handleClick}>
                    <div className="w-4 h-4 rounded-full bg-white shadow transform transition-transform translate-x-5" style={{marginTop: '2px'}}/>
                </div>
            :<div className={`w-10 h-5 rounded-full bg-gray-300 ${disabled ? "cursor-not-allowed" : "cursor-pointer"}`} onClick={handleClick}>
                <div className="w-4 h-4 rounded-full bg-white shadow transform transition-transform translate-x-1 mt-1" style={{marginTop: '2px'}}/>
            </div>
            }
        </>
    )
}

export default ToggleButton;